import { ApolloError } from "@apollo/client";

import { FinanceNotificationRule } from "../generated/graphql";

export const isFinanceNotificationRule = (value: string | null): value is FinanceNotificationRule =>
  Object.values<string>(FinanceNotificationRule).includes(value ?? "");

const berlinDay = new Intl.DateTimeFormat("en-US", {
  timeZone: "Europe/Berlin",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

// The Berlin calendar day of a moment as yyyy-mm-dd, the form Salesforce dates arrive in.
// Built from the parts: the order and separators of a formatted string depend on the locale data.
export const berlinToday = (now: Date = new Date()): string => {
  const parts = berlinDay.formatToParts(now);
  const part = (type: Intl.DateTimeFormatPartTypes) => parts.find(candidate => candidate.type === type)?.value;
  return `${part("year")}-${part("month")}-${part("day")}`;
};

// A contract that ends today still ends; one that ended earlier ended.
export const endsInFuture = (endDate: string, now: Date = new Date()): boolean => endDate >= berlinToday(now);

// The codes the dismissal is refused with; each has a message.
export const FINANCE_NOTIFICATION_ERROR_CODES = [
  "notification-reason-required",
  "notification-not-open",
  "notification-not-found",
] as const;

export type FinanceNotificationErrorCode = (typeof FINANCE_NOTIFICATION_ERROR_CODES)[number];

// The code of a refused dismissal; null for an unexpected error.
export const financeNotificationErrorCode = (error: unknown): FinanceNotificationErrorCode | null => {
  const message = error instanceof ApolloError ? error.graphQLErrors[0]?.message : undefined;
  return FINANCE_NOTIFICATION_ERROR_CODES.find(code => code === message) ?? null;
};
